module.exports = __webpack_public_path__ + "static/media/bcbackend.21131fe9.png";